<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-12-04 23:54:52
 * @LastEditTime : 2024-12-05 14:37:18
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\priceMaintenance.vue
-->
<template>
    <div>
        <el-dialog :visible.sync="visible" width="1280px" :close-on-click-modal="false" @open="open">
            <span slot="title" class="dialog-title">标号信息价</span>
            <div class="pages_content table">
                <el-container style="height: 70vh; display: flex; flex-direction: column;">
                    <el-main style="display: flex">
                        <div class="main_left" style="width: 190px; padding: 20px">
                            <div style="font-size: 16px; font-family: PingFang SC; font-weight: bold">信息价城市</div>
                            <div style="padding-right: 10px">
                                <template v-for="(item, index) in cityList">
                                    <div :key="index">
                                        <el-button size="medium" :class="item.status ? 'bottom_all' : 'bottom_all_two'"
                                            style="margin-left: 24px; margin-top: 10px" @click="buttonChange(index)">{{
                                                item.cityName }}</el-button>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="main_right" style="width:100%">
                            <div class="tabtop">
                                <div v-for="(item, index) in priceTypelist" :key="index" @click="choose(item.id)">
                                    <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
                                    <!-- <div v-if="currenindex !== index + 1 && currenindex !== index + 2 && index !== 2" class="hr"></div> -->
                                </div>
                            </div>
                            <div class="header_right" @click="showCardNav = !showCardNav">
                                <div class="title">搜索</div>
                                <div>
                                    <div>
                                        <div :class="{ arrowTransform: !showCardNav, arrowTransformReturn: showCardNav }">
                                            <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="showCardNav" class="hr"></div>
                            <el-collapse-transition>
                                <div v-show="showCardNav">
                                    <div class="search">
                                        <span style="display: inline-block; margin-bottom: 10px">
                                            <span style="margin-right: 12px">信息价期数：</span>
                                            <el-input v-model="tableParam.dataPeriods"
                                                oninput="value=value.replace(/[^\d]/g,'');if(value<0)value=0;if(value>12)value=12"
                                                style="width: 120px" clearable placeholder="请输入" />
                                        </span>
                                        <span style="margin-left: 24px">
                                            <span style="margin-right: 12px">登记人：</span>
                                            <el-input v-model="tableParam.createUserName" style="width: 240px" clearable
                                                placeholder="请输入" />
                                        </span>
                                        <el-button icon="el-icon-search" size="medium" class="bottom_all"
                                            @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                                        <el-button size="medium" class="bottom_all_two" style="margin-left: 12px"
                                            @click="init()">重 置</el-button>
                                    </div>
                                </div>
                            </el-collapse-transition>
                            <div class="hr"></div>
                            <div class="card">
                                <div v-loading="tableLoading" class="card_info">
                                    <el-table :header-cell-style="{ background: '#f3f6f9' }"
                                        :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%"
                                        :data="tableData" tooltip-effect="dark">
                                        <template v-for="(item, index2) in table">
                                            <el-table-column v-if="item.status" :key="index2" :label="item.label"
                                                align="center" :min-width="item.width"
                                                :fixed="item.label == '操作' ? 'right' : false">
                                                <template slot-scope="scope">
                                                    <span v-if="item.label == '信息价期数'"> {{ scope.row.dataYear }}年 第{{
                                                        scope.row.dataPeriods }}期 </span>
                                                    <span v-else-if="item.label == '状态'">
                                                        <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
                                                        <span v-if="scope.row.enable == 1" style="color: #00a754">启用</span>
                                                    </span>
                                                    <div v-else-if="item.label == '操作'">
                                                        <el-button class="bottom_one" size="mini"
                                                            @click="update(scope.row, '查看')">查看</el-button>
                                                    </div>
                                                    <span v-else>{{ scope.row[item.prop] }}</span>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </el-main>
                    <div class="card_bottom">
                        <div class="card_bottom_left">
                            <div class="top_page_totle">总共{{ total }}条</div>
                            <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
                                :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
                                layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange"
                                @current-change="gettableData()"></el-pagination>
                        </div>
                        <div>
                            <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                                @click="gettableData">刷新</el-button>
                        </div>
                    </div>
                </el-container>
                <el-dialog :visible.sync="addDialog" width="1180px" append-to-body  :close-on-click-modal="false"
                    :before-close="resetFromDate">
                    <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
                    <div>
                        <div class="top">
                            <div>
                                <span>期数：</span>
                                <el-input v-model="fromDate.dataYear" class="input1" style="width: 120px"
                                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))">
                                    <div slot="suffix" style="line-height: 36px">年</div>
                                </el-input>
                                <el-input v-model="fromDate.dataPeriods"
                                    onblur="if(value > 12 ){value = 12}else if(value < 1 ){ value = 1}"
                                    onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))" class="input2"
                                    style="width: 100px">
                                    <div slot="prefix" style="line-height: 36px">第</div>
                                    <div slot="suffix" style="line-height: 36px">期</div>
                                </el-input>
                            </div>
                            <div class="top">
                                <span>生效时间：</span>
                                <el-date-picker v-model="fromDate.time" value-format="yyyy-MM-dd HH:mm:ss" type="daterange"
                                    placeholder="选择日期时间" ange-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </div>
                        </div>
                        <div style="padding-top: 20px">
                            <!-- <el-button size="mini" class="bottom_all" style="margin-left: 0" @click="addline()">
              <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
              添加行
            </el-button> -->
                            <el-button size="mini" class="bottom_all" style="margin-left: 12px" @click="exportExample()">
                                导出信息价模板 </el-button>
                            <div v-if="addDialogTitle == '修改'" style="float: right">
                                <span>以下价格为不含税价格</span>
                                <el-button size="mini" class="bottom_all" style="margin-left: 12px" @click="renewStyle()">
                                    更新样式 </el-button>
                            </div>
                            <!-- <el-button size="mini" class="bottom_all" style="margin-left: 12px" @click="addColume(2)">
              <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
              添加标号
            </el-button>
            <el-button size="mini" class="bottom_all" style="margin-left: 12px" @click="addColume(3)">
              <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
              添加原物料
            </el-button> -->
                            <el-upload style="float: left" action="/icps/system/sign/basics/information/price/importList"
                                :disabled="fromDate.dataYear == '' || fromDate.dataPeriods == '' || fromDate.time == ''"
                                :show-file-list="false" :before-upload="filebefore" :on-success="filesuccess"
                                :headers="upheader" :data="{
                                    type: currenindex,
                                    dataYear: fromDate.dataYear,
                                    dataPeriods: fromDate.dataPeriods,
                                    startTime: fromDate.time[0],
                                    endTime: fromDate.time[1],
                                    cityDode: priceStyleForm.cityDode,
                                    cityName: priceStyleForm.cityName,
                                }">
                                <el-button size="mini" class="bottom_all" style="margin-left: 12px"
                                    :disabled="fromDate.dataYear == '' || fromDate.dataPeriods == '' || fromDate.time == ''">导入信息价</el-button>
                            </el-upload>
                        </div>
                        <div style="padding-top: 15px">
                            <el-table :key="currenindex" :header-cell-style="{ background: '#f3f6f9' }"
                                :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="lineList"
                                tooltip-effect="dark" height="520px">
                                <template v-for="(item, index2) in columnList">
                                    <el-table-column v-if="index2 == 0" :key="index2" width="120px" :label="item.itemName"
                                        align="center">
                                        <template slot="header">
                                            <div class="xieXian">
                                                <div></div>
                                                <span>区域</span>
                                                <span>标号</span>
                                            </div>
                                        </template>
                                        <template slot-scope="scope">
                                            {{ scope.row.itemCode }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-else-if="item.type === 1" :key="index2" :label="item.itemName"
                                        :prop="item.itemName" align="center" width="160px">
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row[item.itemName]" style="width: 100%"
                                                onblur="if(value > 10000 ){ value = 10000}else if(value && value < 1  ){ value = 1}"
                                                onkeypress="return( /^[1-9]{1}\d\.)*$/.test(String.fromCharCode(event.keyCode)))"
                                                @input="scope.row[item.itemName] = $regExp.checkNum(scope.row[item.itemName])"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-else-if="item.type === 2" :key="index2" width="200px">
                                        <template slot="header" slot-scope="scope">
                                            <el-select :ref="scope.row" v-model="item.itemName" placeholder="请选择"
                                                style="width: 60%">
                                                <el-option v-for="item in currenindex == 1 ? gradeList : gradeList2"
                                                    :key="item.id" :label="item.name" :value="item.id"> </el-option>
                                            </el-select>
                                            <el-button style="margin-left: 5px" class="bottom_text"
                                                @click="deleteColumn(index2)">删除</el-button>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row[item.itemName]" style="width: 100%"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column v-else-if="item.type === 3" :key="index2" width="200px">
                                        <template slot="header" slot-scope="scope">
                                            <el-input :ref="scope.row" v-model="item.itemName"
                                                style="width: 60%"></el-input>
                                            <el-button style="margin-left: 5px" class="bottom_text"
                                                @click="deleteColumn(index2)">删除</el-button>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-input v-model="scope.row[item.itemName]" style="width: 100%"></el-input>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button class="bottom_all_two" @click="resetFromDate">关 闭</el-button>
                    </span>
                </el-dialog>
                <!-- 信息价样式 -->
                <el-dialog v-dialogDrag :visible.sync="priceStyleDig" width="620px" :close-on-click-modal="false"
                    :before-close="closePriceStyle">
                    <span slot="title" class="dialog-title">信息价样式</span>
                    <el-tabs v-model="priceStyleActive" type="card" @tab-click="queryPatternList()">
                        <template v-for="(item, index) in priceTypelist">
                            <el-tab-pane :key="index" :label="item.value" :name="item.id">
                                <div style="display: flex; margin-top: 10px">
                                    <el-card class="box-card" style="margin-left: 24px">
                                        <div slot="header" class="clearfix">
                                            <span>标号</span>
                                        </div>
                                        <div class="card-content">
                                            <div v-for="(item, index) in gradeStyleList" :key="index" class="text item">
                                                <div class="card-item">
                                                    <span>{{ item.name }}</span>
                                                    <el-link type="danger" style="margin-right: 5px" :underline="false"
                                                        @click="deletePattern(item.id)">删除</el-link>
                                                </div>
                                            </div>
                                        </div>
                                    </el-card>
                                    <el-button size="mini" class="bottom_all" style="margin-left: 96px; height: 28px"
                                        @click="addPriceStyleDig = true, priceStyleActive == 4 ? (priceStyleForm.type = 2) : (priceStyleForm.type = 1)">添
                                        加</el-button>
                                </div>
                            </el-tab-pane></template>
                        <el-tab-pane label="区域" name="4">
                            <div style="display: flex; margin-top: 10px">
                                <el-card class="box-card" style="margin-left: 24px">
                                    <div slot="header" class="clearfix">
                                        <span>区域</span>
                                    </div>
                                    <div class="card-content">
                                        <div v-for="(item, index) in areaList" :key="index" class="text item">
                                            <div class="card-item">
                                                <span>{{ item.name }}</span>
                                                <!-- <el-link type="danger" style="margin-right: 5px" :underline="false" @click="deletePattern(item.id)">删除</el-link> -->
                                            </div>
                                        </div>
                                    </div>
                                </el-card>
                                <el-button size="mini" class="bottom_all" style="margin-left: 96px; height: 28px"
                                    @click="addPriceStyleDig = true, priceStyleActive == 4 ? (priceStyleForm.type = 2) : (priceStyleForm.type = 1)">添
                                    加</el-button>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <span slot="footer" class="dialog-footer">
                        <el-button class="bottom_all_two" @click="closePriceStyle">关 闭</el-button>
                    </span>
                </el-dialog>
                <!-- 添加信息价样式 -->
                <el-dialog title="添加" :visible.sync="addPriceStyleDig" width="500px" :close-on-click-modal="false"
                    @close="closeAddPriceStyle">
                    <el-form :model="priceStyleForm" class="demo-form" label-width="120px;">
                        <el-form-item label="类型：">
                            <el-select v-model="priceStyleForm.type" disabled placeholder="请选择" style="width: 52%">
                                <el-option :key="1" label="标号" :value="1"> </el-option>
                                <el-option :key="2" label="区县" :value="2"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="名称：">
                            <el-select v-if="priceStyleForm.type == 1" v-model="priceStyleForm.gradeId" placeholder="请选择"
                                clearable style="width: 52%">
                                <el-option v-for="item in priceStyleGradeList" :key="item.id" :label="item.name"
                                    :value="item.id" @click.native="priceStyleForm.name = item.name"> </el-option>
                            </el-select>
                            <el-input v-if="priceStyleForm.type == 2" v-model="priceStyleForm.name"
                                placeholder="请输入区县"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button class="bottom_all_two" @click="closeAddPriceStyle">取 消</el-button>
                        <el-button class="bottom_all" type="primary" @click="savePriceStyle">确 定</el-button>
                    </span>
                </el-dialog>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button class="bottom_all_two" @click="reset">取 消</el-button> -->
                <el-button class="bottom_all" @click="reset">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { getUserInfo, getToken, getUserId } from "@/utils/auth";
import { queryPage, queryDetail, deletePrice, savePrice, exportExample, queryPatternList, savePattern, deletePattern, getListByTypeId, updateTabel } from "@/api/basicConfig/priceMaintenance.js";
import { getStrengthGtadeLists } from "@/api/basicConfig/companyStandard";
import { sortReg } from "@/common/RegExp.js";
import { mapGetters } from "vuex";
export default {
    mixins: [mixin],
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        var validatePass1 = (rule, value, callback) => {
            if (sortReg(value)) {
                callback();
            } else {
                callback(new Error("请输正整数序号!"));
            }
        };
        return {
            queryPage: queryPage,
            upheader: {
                "access-token": getToken(),
                "user-id": getUserId(),
            },
            /*表格数据*/
            table: [
                { label: "信息价期数", width: "auto", prop: "dataPeriods", status: true },
                { label: "信息价登记人", width: "120", prop: "createUserName", status: true },
                { label: "生效日期", width: "120", prop: "startTime", status: true },
                { label: "操作", width: "120", prop: "", status: true },
            ],
            pagesType: 0,
            /*添加表单数据*/
            rules: {
                code: [
                    { required: true, message: "请输入站点编码", trigger: "blur" },
                    { validator: validatePass1, trigger: "blur" },
                ],
            },
            priceTypelist: [
                {
                    value: "混凝土信息价",
                    id: 1,
                },
                {
                    value: "湿拌砂浆信息价",
                    id: 2,
                },
                {
                    value: "干混砂浆信息价",
                    id: 3,
                },
            ],
            currenindex: 1,
            fromDate: {
                id: "",
                dataYear: "",
                dataPeriods: "",
                // informationPriceType:'',
                time: [],
            },
            lineList: [],
            //混凝土信息价添加 表头
            columnLists1: [
                {
                    itemName: "itemCode",
                    type: 1,
                },
                {
                    itemName: "C10",
                    type: 1,
                },
                {
                    itemName: "C15",
                    type: 1,
                },
                {
                    itemName: "C20",
                    type: 1,
                },
                {
                    itemName: "C25",
                    type: 1,
                },
                {
                    itemName: "C30",
                    type: 1,
                },
                {
                    itemName: "C35",
                    type: 1,
                },
                {
                    itemName: "C40",
                    type: 1,
                },
                {
                    itemName: "C45",
                    type: 1,
                },
                {
                    itemName: "C50",
                    type: 1,
                },
                {
                    itemName: "C55",
                    type: 1,
                },
                {
                    itemName: "C60",
                    type: 1,
                },
                {
                    itemName: "C65",
                    type: 1,
                },
                {
                    itemName: "C70",
                    type: 1,
                },
                {
                    itemName: "C75",
                    type: 1,
                },
                {
                    itemName: "C80",
                    type: 1,
                },
            ],
            //湿拌砂浆信息价添加 表头
            columnLists2: [
                {
                    itemName: "itemCode",
                    type: 1,
                },
                {
                    itemName: "地面砂浆M5",
                    type: 1,
                },
                {
                    itemName: "地面砂浆M7.5",
                    type: 1,
                },
                {
                    itemName: "地面砂浆M10",
                    type: 1,
                },
                {
                    itemName: "地面砂浆M15",
                    type: 1,
                },
                {
                    itemName: "地面砂浆M20",
                    type: 1,
                },
                {
                    itemName: "地面砂浆M25",
                    type: 1,
                },
                {
                    itemName: "地面砂浆M30",
                    type: 1,
                },
                {
                    itemName: "抹灰砂浆M5",
                    type: 1,
                },
                {
                    itemName: "抹灰砂浆M7.5",
                    type: 1,
                },
                {
                    itemName: "抹灰砂浆M10",
                    type: 1,
                },
                {
                    itemName: "抹灰砂浆M15",
                    type: 1,
                },
                {
                    itemName: "抹灰砂浆M20",
                    type: 1,
                },
                {
                    itemName: "抹灰砂浆M25",
                    type: 1,
                },
                {
                    itemName: "砌筑砂浆M5",
                    type: 1,
                },
                {
                    itemName: "砌筑砂浆M7.5",
                    type: 1,
                },
                {
                    itemName: "砌筑砂浆M10",
                    type: 1,
                },
                {
                    itemName: "砌筑砂浆M15",
                    type: 1,
                },
                {
                    itemName: "砌筑砂浆M20",
                    type: 1,
                },
                {
                    itemName: "砌筑砂浆M25",
                    type: 1,
                },

                {
                    itemName: "砌筑砂浆M30",
                    type: 1,
                },
            ],
            //干混砂浆信息价添加 表头
            columnLists3: [
                {
                    itemName: "itemCode",
                    type: 1,
                },
                {
                    itemName: "干混地面砂浆M5",
                    type: 1,
                },
                {
                    itemName: "干混地面砂浆M7.5",
                    type: 1,
                },
                {
                    itemName: "干混地面砂浆M10",
                    type: 1,
                },
                {
                    itemName: "干混地面砂浆M15",
                    type: 1,
                },
                {
                    itemName: "干混地面砂浆M20",
                    type: 1,
                },
                {
                    itemName: "干混地面砂浆M25",
                    type: 1,
                },
                {
                    itemName: "干混地面砂浆M30",
                    type: 1,
                },
                {
                    itemName: "干混抹灰砂浆M5",
                    type: 1,
                },
                {
                    itemName: "干混抹灰砂浆M7.5",
                    type: 1,
                },
                {
                    itemName: "干混抹灰砂浆M10",
                    type: 1,
                },
                {
                    itemName: "干混抹灰砂浆M15",
                    type: 1,
                },
                {
                    itemName: "干混抹灰砂浆M20",
                    type: 1,
                },
                {
                    itemName: "干混抹灰砂浆M25",
                    type: 1,
                },
                {
                    itemName: "干混砌筑砂浆M5",
                    type: 1,
                },
                {
                    itemName: "干混砌筑砂浆M7.5",
                    type: 1,
                },
                {
                    itemName: "干混砌筑砂浆M10",
                    type: 1,
                },
                {
                    itemName: "干混砌筑砂浆M15",
                    type: 1,
                },
                {
                    itemName: "干混砌筑砂浆M20",
                    type: 1,
                },
                {
                    itemName: "干混砌筑砂浆M25",
                    type: 1,
                },

                {
                    itemName: "干混砌筑砂浆M30",
                    type: 1,
                },
            ],
            columnList: [],
            defaultGrade: ["C10", "C15", "C20", "C25", "C30", "C35", "C40", "C45", "C50", "C55", "C60", "C65", "C70", "C75", "C80"], //混凝土信息价默认
            defaultGrade2: [
                "地面砂浆M5",
                "抹灰砂浆M5",
                "砌筑砂浆M5",
                "地面砂浆M7.5",
                "抹灰砂浆M7.5",
                "砌筑砂浆M7.5",
                "地面砂浆M10",
                "抹灰砂浆M10",
                "砌筑砂浆M10",
                "地面砂浆M15",
                "抹灰砂浆M15",
                "砌筑砂浆M15",
                "地面砂浆M20",
                "抹灰砂浆M20",
                "砌筑砂浆M20",
                "地面砂浆M25",
                "抹灰砂浆M25",
                "砌筑砂浆M25",
                "地面砂浆M30",
                "砌筑砂浆M30",
            ], //砂浆信息价默认
            gradeList: [], //混凝土
            gradeList2: [], //湿拌砂浆
            gradeList3: [], //干拌砂浆
            TreeSelectStypeNumber: 0,
            selectRow: "",
            nameArr: ["成都市区", "天府新区", "崇州市", "大邑县", "都江堰市", "金堂县", "龙泉驿区", "彭州市", "郫都区", "蒲江县", "青白江区", "邛崃市", "双流区", "温江区", "新都区", "新津区", "简阳市", "东部新区"],
            cityList: [
                {
                    cityName: "重庆",
                    cityDode: "chongqing",
                    buttonCode: "CHONGQING",
                    status: false,
                },
                {
                    cityName: "成都",
                    cityDode: "chendu",
                    buttonCode: "CHENGDU",
                    status: false,
                },
                {
                    cityName: "绵竹",
                    cityDode: "mianzhu",
                    buttonCode: "MIANZHU",
                    status: false,
                },
                {
                    cityName: "遂宁",
                    cityDode: "suining",
                    buttonCode: "SUINING",
                    status: false,
                },
                {
                    cityName: "资阳",
                    cityDode: "ziyang",
                    buttonCode: "ZIYANG",
                    status: false,
                },
                {
                    cityName: "德阳",
                    cityDode: "deyang",
                    buttonCode: "DEYANG",
                    status: false,
                },
                {
                    cityName: "眉山",
                    cityDode: "meishan",
                    buttonCode: "MEISHAN",
                    status: false,
                },
                {
                    cityName: "宜宾",
                    cityDode: "yibin",
                    buttonCode: "YIBIN",
                    status: false,
                },
                {
                    cityName: "内江",
                    cityDode: "neijiang",
                    buttonCode: "NEIJIANG",
                    status: false,
                },
                {
                  cityName: "西昌",
                  cityDode: "xichang",
                  buttonCode: "XICHANG",
                  status: false,
                },
                {
                  cityName: "绵阳",
                  cityDode: "mianyang",
                  buttonCode: "MIANYANG",
                  status: false,
                },
                {
                  cityName: "广安",
                  cityDode: "guangan",
                  buttonCode: "GUANGAN",
                  status: false,
                },
                {
                  cityName: "达州",
                  cityDode: "dazhou",
                  buttonCode: "DAZHOU",
                  status: false,
                },
                {
                  cityName: "南充",
                  cityDode: "nanchong",
                  buttonCode: "NANCHONG",
                  status: false,
                },
                {
                  cityName: "乐山",
                  cityDode: "leshan",
                  buttonCode: "LESHAN",
                  status: false,
                },
            ],
            priceStyleDig: false,
            addPriceStyleDig: false,
            priceStyleForm: {
                type: 1,
                informationPriceType: 1,
                name: "",
                gradeId: "",
                cityDode: "",
                cityName: "",
            },
            gradeStyleList: [],
            areaList: [],
            priceStyleActive: 1,
            priceStyleGradeList: [],
        };
    },
    async created() {

    },
    async mounted() {
        
    },
    watch: {
        currenindex: {
            //data所有属性都进行监听器，可使用字符串的形式监听对象属性（'item.item1'）
            handler() {
                this.tableParam.informationPriceType = this.currenindex;
                this.tableParam.page = 1;
                this.init();
            },
            deep: false,
            immediate: false,
        },
    },
    /*
     *copy(data)深拷贝数据,返回拷贝完的数据
     *gettableData获取列表数据
     *load下载
     *SortNum保持序列号
     * UpdateOrDelete禁用，启用，删除
     * submitFromDate保存更新数据
     */
    methods: {
        reset() {
            this.$emit("reset");
        },
      async open(){
            /*存储拷贝的原初始化fromDate数据*/
        this.tableParam = { ...this.tableParam, dataPeriods: "", createUserName: "", informationPriceType: this.currenindex };
        this.cityList[0].status = true;
        this.tableParam.cityDode = this.cityList[0].cityDode;

        await this.queryPatternList();
        await this.gettableData();
        /**
         * @Description: 获取标号
         * @param {*}
         * @Author: wangwangwang
         */
        // this.initCodeList();
        this.priceStyleForm.cityDode = this.cityList[0].cityDode;
        this.priceStyleForm.cityName = this.cityList[0].cityName;
        getListByTypeId({ typeId: 1 }).then(res => {
            if (res.code == 1001) {
                this.priceStyleGradeList = res.data
            }
        })
        },
        //信息价样式  开始
        //更新样式
        renewStyle() {
            this.$confirm("此操作将更新信息价样式?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "bottom_all_two",
                confirmButtonClass: "bottom_all",
                type: "warning",
            })
                .then(() => {
                    updateTabel({ id: this.selectRow.id }).then(res => {
                        if (res.code == 1001) {
                            this.update(this.selectRow, '修改', '更新成功')
                        }
                    })
                })
                .catch(() => { });
        },
        //删除
        deletePattern(id) {
            this.$confirm("此操作将永久删除该信息?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "bottom_all_two",
                confirmButtonClass: "bottom_all",
                type: "warning",
            })
                .then(() => {
                    let params = {
                        id: id,
                    };
                    deletePattern(params).then(res => {
                        if (res.code == 1001) {
                            this.$message.success("删除成功！");
                            this.queryPatternList();
                        }
                    });
                })
                .catch(() => { });
        },
        savePriceStyle() {
            this.priceStyleForm.informationPriceType = this.priceStyleActive;
            savePattern(this.priceStyleForm).then(res => {
                if (res.code == 1001) {
                    this.$message.success("添加成功！");
                    this.queryPatternList();
                    this.closeAddPriceStyle();
                }
            });
        },
        queryPatternList(text) {
            queryPatternList({
                cityDode: this.tableParam.cityDode,
                informationPriceType: this.currenindex,
            }).then(res => {
                if (res.code == 1001) {
                    let gradeList = [];
                    if (this.priceStyleDig == true) {
                        if (this.priceStyleActive == 1) {
                            gradeList = res.data.gradeOneList;
                        } else if (this.priceStyleActive == 2) {
                            gradeList = res.data.gradetwoList;
                        } else {
                            gradeList = res.data.gradethreeList;
                        }
                    } else {
                        if (this.currenindex == 1) {
                            gradeList = res.data.gradeOneList;
                        } else if (this.currenindex == 2) {
                            gradeList = res.data.gradetwoList;
                        } else {
                            gradeList = res.data.gradethreeList;
                        }
                    }

                    this.gradeStyleList = JSON.parse(JSON.stringify(gradeList || []));
                    this.areaList = JSON.parse(JSON.stringify(res.data.areaList || []));
                    let columnLists = gradeList || [];
                    let rowLists = res.data.areaList || [];
                    this.nameArr = [];
                    rowLists.forEach(item => {
                        this.nameArr.push({
                            areaName: item.name,
                            areaCode: item.id,
                        });
                    });
                    columnLists.unshift({
                        name: "itemCode",
                        type: 1,
                        id: "itemCode",
                        gradeId: "itemCode",
                    });
                    columnLists.forEach(item => {
                        item["itemName"] = item.name;
                        item["itemCode"] = item.id;
                    });
                    if (this.currenindex == 1) {
                        this.columnLists1 = columnLists;
                    }
                    if (this.currenindex == 2) {
                        this.columnLists2 = columnLists;
                    }
                    if (this.currenindex == 3) {
                        this.columnLists3 = columnLists;
                    }
                    if (text == 'add') {
                        this.add('添加', this.currenindex)
                    }
                }
            });
        },
        closePriceStyle() {
            this.priceStyleDig = false;
        },
        closeAddPriceStyle() {
            this.addPriceStyleDig = false;
            this.priceStyleForm.name = "";
            this.priceStyleForm.type = "";
            this.priceStyleForm.gradeId = "";
        },
        /*切换城市 */
        buttonChange(index) {
            this.cityList.forEach(item => {
                item.status = false;
            });
            this.cityList[index].status = true;
            this.tableParam.cityDode = this.cityList[index].cityDode;
            this.priceStyleForm.cityDode = this.cityList[index].cityDode;
            this.priceStyleForm.cityName = this.cityList[index].cityName;
            this.gettableData();
            this.queryPatternList();
        },
        //信息价样式  结束
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParam = { ...this.tableParam, dataPeriods: "", createUserName: "", informationPriceType: this.currenindex };
            this.gettableData();
        },
        choose(num) {
            this.currenindex = num;
        },
        /**添加数据*/
        add(text, num) {
            this.columnList = [];
            if (this.currenindex == 1) {
                this.columnList = this.columnLists1;
            }
            if (this.currenindex == 2) {
                this.columnList = this.columnLists2;
            }
            if (this.currenindex == 3) {
                this.columnList = this.columnLists3;
            }
            console.log(this.columnList);
            this.addDialogTitle = text;
            this.selectRow = "";
            this.fromDate = {
                dataYear: "",
                dataPeriods: "",
                time: [],
                informationPriceType: num,
            };
            this.lineList = [];
            this.nameArr.forEach(v => {
                this.addline(v);
            });
            this.addDialog = true;
        },
        /**修改数据*/
        update(low, text, message) {
            this.addDialog = true;
            this.addDialogTitle = text;
            this.selectRow = low;
            queryDetail({ id: low.id }).then(res => {
                if (res.code === 1001) {
                    this.fromDate = {
                        id: res.data.id,
                        dataYear: res.data.dataYear,
                        dataPeriods: res.data.dataPeriods,
                        time: [res.data.startTime, res.data.endTime],
                    };
                    const columnList = [
                        {
                            itemName: "itemCode",
                            type: 1,
                            itemCode: "itemCode",
                        },
                    ];
                    const lineList = [];
                    /**
                     * @Description: 构造表头
                     * @param {*} let
                     * @Author: wangwangwang
                     */
                    for (let i = 0; i < res.data.tableLable.length; i += 1) {
                        const data = {
                            itemName: res.data.tableLable[i].itemName,
                            itemCode: res.data.tableLable[i].itemCode,
                            gradeId: res.data.tableLable[i].gradeId,
                            type: res.data.tableLable[i].type * 1,
                        };
                        columnList.push(data);
                    }
                    this.columnList = columnList;
                    /**
                     * @Description: 构造数据
                     * @param {*}
                     * @Author: wangwangwang
                     */
                    // for (let i = 0; i < this.nameArr.length; i += 1) {
                    //   const data = {
                    //     itemCode: this.nameArr[i],
                    //     areaCode: i + 1,
                    //   };
                    //   for (let j = 0; j < res.data.valueList.length; j += 1) {
                    //     if (res.data.valueList[j].areaCode == String(i + 1)) {
                    //       data[res.data.valueList[j].lableId] = res.data.valueList[j].dataValue;
                    //       data["itemName"] = res.data.valueList[j].dataValue;
                    //     }
                    //   }
                    //   lineList.push(data);
                    // }
                    res.data.tableArea.forEach(item => {
                        const data = {
                            areaCode: item.itemCode,
                            itemCode: item.itemName,
                        };
                        res.data.tableLable.forEach(item2 => {
                            let cell = res.data.valueList.find(res => res.lableId == item2.id && res.areaCode == item.id);
                            data[item2.itemName] = cell?.dataValue || "";
                            data.lableId = cell?.lableId || "";
                        });
                        lineList.push(data);
                    });
                    this.lineList = lineList;
                    console.log(JSON.parse(JSON.stringify(this.lineList)));
                    if (message) {
                        this.$message.success(message)
                    }

                }
            });
        },
        /**删除数据*/
        deldata(low) {
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "bottom_all_two",
                confirmButtonClass: "bottom_all",
                type: "warning",
            })
                .then(() => {
                    deletePrice({ id: low.id, status: 0 }).then(res => {
                        if (res.code == 1001) {
                            this.gettableData();
                        }
                    });
                })
                .catch(() => { });
        },
        /**添加行*/
        addline(item) {
            const data = {};
            for (let i = 0; i < this.columnList.length; i += 1) {
                data[this.columnList[i].itemName] = "";
            }
            data.areaCode = item.areaCode;
            data.itemCode = item.areaName;
            this.lineList.push(data);
            console.log(this.lineList);
        },
        /**
         * @Description: 添加列
         * @param {*}
         * @Author: wangwangwang
         */
        addColume(type) {
            this.columnList.push({
                type,
                itemName: "",
            });
        },
        /**导入信息价*/
        filesuccess(res) {
            if (res.code === 1001) {
                this.$message.success("导入成功");
                this.fromDate = {
                    id: res.data.id,
                    dataYear: res.data.dataYear,
                    dataPeriods: res.data.dataPeriods,
                    time: [res.data.startTime, res.data.endTime],
                };
                const columnList = [
                    {
                        itemName: "itemCode",
                        type: 1,
                    },
                ];
                const lineList = [];
                /**
                 * @Description: 构造表头
                 * @param {*} let
                 * @Author: yangxr
                 */
                for (let i = 0; i < res.data.tableLable.length; i += 1) {
                    const data = {
                        itemName: res.data.tableLable[i].itemName,
                        itemCode: res.data.tableLable[i].itemCode,
                        gradeId: res.data.tableLable[i].gradeId,
                        type: res.data.tableLable[i].type * 1,
                    };
                    columnList.push(data);
                }
                this.columnList = columnList;
                /**
                 * @Description: 构造数据
                 * @param {*}
                 * @Author: yangxr
                 */
                res.data.tableArea.forEach(item => {
                    const data = {
                        areaCode: item.itemCode,
                        itemCode: item.itemName,
                    };
                    res.data.tableLable.forEach(item2 => {
                        let cell = res.data.valueList.find(res => res.lableId == item2.id && res.areaCode == item.id);
                        data[item2.itemName] = cell.dataValue;
                        data.lableId = cell.lableId;
                    });
                    lineList.push(data);
                });
                this.lineList = lineList;
                console.log(JSON.parse(JSON.stringify(this.lineList)));
            } else {
                this.$message.error(res.codeMsg);
            }
        },
        filebefore(file) {
            this.loading = true;
            const isJPG = file.type === "application/vnd.ms-excel";
            if (!isJPG) {
                this.$message.error("数据上传必须是 xls 格式!");
                this.loading = false;
            }
            return isJPG;
        },
        //导出模板
        exportExample() {
            this.$Download(exportExample, { informationPriceType: this.currenindex, cityDode: this.priceStyleForm.cityDode });
        },
        /**保存数据*/
        submit1() {
            if (!this.fromDate.dataYear || !this.fromDate.dataPeriods) {
                this.$message({
                    showClose: true,
                    message: "警告哦，请填写期数",
                    type: "warning",
                });
                return;
            }
            if (!this.fromDate.time) {
                this.$message({
                    showClose: true,
                    message: "警告哦，请选择时间",
                    type: "warning",
                });
                return;
            }
            const tableList = [];
            const valueList = [];
            for (let i = 0; i < this.columnList.length; i += 1) {
                if (this.columnList[i].itemName !== "itemCode") {
                    const data = {
                        itemCode: this.columnList[i].itemCode,
                        itemName: this.columnList[i].itemName,
                        gradeId: this.columnList[i].gradeId,
                        type: 1,
                    };
                    tableList.push(data);
                }
            }
            for (let i = 0; i < this.lineList.length; i += 1) {
                const areaData = {
                    itemCode: this.lineList[i].areaCode,
                    itemName: this.lineList[i].itemCode,
                    type: 2,
                };
                tableList.push(areaData);
                const List = this.lineList[i];
                const keysList = Object.keys(List);
                for (let j in keysList) {
                    if (keysList[j] && keysList[j] !== "itemCode" && keysList[j] !== "areaCode" && keysList[j] !== "lableId") {
                        let lableId = this.columnList.find(res => res.itemName == keysList[j]);
                        const data = {
                            areaCode: List.areaCode,
                            lableId: lableId?.itemCode,
                            dataValue: List[keysList[j]],
                        };
                        valueList.push(data);
                    }
                }
            }
            let data = {
                ...this.fromDate,
                startTime: this.fromDate.time[0],
                endTime: this.fromDate.time[1],
                company: this.selectRow?.company || getUserInfo().companyName,
                companyId: this.selectRow?.companyId || getUserInfo().companyId,
                tableList,
                valueList,
                informationPriceType: this.currenindex,
                cityName: this.priceStyleForm.cityName,
                cityDode: this.priceStyleForm.cityDode,
            };
            const loading = this.$loading({});
            savePrice(data).then(res => {
                loading.close();
                if (res.code == 1001) {
                    this.$message({
                        message: "保存成功",
                        type: "success",
                    });
                    this.gettableData();
                    this.addDialog = false;
                }
            });
        },
        initCodeList() {
            // getLists().then(res => {
            //   if (res.code === 1001) {
            //     const newData = res.data[0].list.filter(item => !this.defaultGrade.includes(item.name));
            //     this.gradeList = newData;
            //   }
            // })
            //混凝土信息价
            getStrengthGtadeLists({ strengthGradeType: 1 }).then(res => {
                if (res.code === 1001) {
                    const newData = res.data.filter(item => !this.defaultGrade.includes(item.name));
                    this.gradeList = newData;
                    console.log(this.gradeList);
                }
            });
            //砂浆信息价
            getStrengthGtadeLists({ strengthGradeType: 2 }).then(res => {
                if (res.code === 1001) {
                    const newData = res.data.filter(item => !this.defaultGrade2.includes(item.name));
                    this.gradeList2 = newData;
                }
            });
        },
        // changeArea(value, label, extra, index) {
        //   const areaCode = [extra.triggerNode.$parent.$parent.$options.propsData.value, extra.triggerNode.$parent.$options.propsData.value, value];
        //   const copyData = this.lineList.map((item, idx) => index === idx ? { ...item, areaCode } : { ...item });
        //   this.lineList = copyData;
        // },
        deleteRow(index) {
            this.lineList.splice(index, 1);
        },
        deleteColumn(index) {
            this.columnList.splice(index, 1);
        },
        TreeSelectStypeFun() {
            if (this.TreeSelectStypeNumber === 0) {
                this.TreeSelectStypeNumber = 1;
                setTimeout(() => {
                    const dom = document.body.lastChild;
                    dom.style.zIndex = "10000";
                }, 1000);
            }
        },
        sizeChange(value) {
            this.tableParam.pageSize = value;
            this.gettableData();
        },
    },
    computed: {
        ...mapGetters({
            screenWidth: "getscreenWidth",
            screenHeight: "getscreenHeight",
            Collapse: "getsCollapse",
        }),
        style() {
            let num = 0;
            if (this.Collapse) {
                num = this.screenWidth - 325;
            } else {
                num = this.screenWidth - 421;
            }
            return "width:" + num + "px;";
        },
    },
};
</script>
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.top {
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>
<style lang="scss">
.tabtop {
    width: 570px;
}

.priceMaintenance {
    .input1 {
        .el-input__inner {
            border-right: 0;
            border-top-right-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
        }
    }

    .input2 {
        .el-input__inner {
            border-left: 0px;
            border-top-left-radius: 0 !important;
            border-bottom-left-radius: 0 !important;
        }
    }

    .xieXian {
        position: relative;
        height: 40px;
        overflow: hidden;

        >div:nth-of-type(1) {
            position: absolute;
            top: 45px;
            left: 0;
            transform: rotateZ(24deg);
            width: 208px;
            height: 1px;
            background: #c1c1c1;
        }

        >span:nth-of-type(1) {
            position: absolute;
            left: 0;
            top: 20px;
        }

        >span:nth-of-type(2) {
            position: absolute;
            left: 55px;
            top: 4px;
        }
    }
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.box-card {
    width: 320px;
}

.card-content {
    height: 420px;
    overflow: auto;
}

.card-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}</style>
  